/**
 * Class representing AuthenticateController. This class uses the LoginService class
 * @memberOf app.authenticate
 * @ngdoc controller
 * @name AuthenticateController
 */
export default class AuthenticateController {

  constructor($state, $location, LoginService) {
    /**
     * @memberOf AuthenticateController
     * @type {service}
     * @description ui-router $state provider
     */
    this.$state = $state;

    /**
     * @memberOf AuthenticateController
     * @type {service}
     * @description Instance of angular $location service
     */
    this.$location = $location;

    /**
     * @memberOf AuthenticateController
     * @type {LoginService}
     * @description Instance of LoginService
     */
    this.loginService = LoginService;
  }

  /**
   * @memberOf AuthenticateController
   * @description Searches the url for uid and token parameters, tries to authenticate by called authenticate method
   */
  login() {
    let params = this.$location.search();
    if (params.uid && params.token) {
      /**
       * @memberOf AuthenticateController
       * @type {string}
       * @description User uid from magic link
       */
      this.uid = params.uid;

      /**
       * @memberOf AuthenticateController
       * @type {string}
       * @description User token from magic link
       */
      this.token = params.token;
      this.authenticate(this.uid, this.token);
    }
  }

  /**
   * @memberOf AuthenticateController
   * @description Logout by calling LoginService.logout();
   */
  logout() {
    this.loginService.logout();
    this.$state.go('login');
  }

  /**
   * @memberOf AuthenticateController
   * @param {string} uid string in url from magic link
   * @param {string} token string in url from magic link
   * @description Authenticate user by calling LoginService.login(uid,token), changes state to home
   * if response is successful, otherwise changes state to login
   */
  authenticate(uid, token) {
    this.loginService.login(uid, token).then(
      (response) => {
        if (response.success) {
          this.$state.go('accept');
        } else {
          this.$state.go('accept', { failedLogin: true });
        }
      }).catch((error) => {
        console.log(error);
      });
  }

  /**
   * @memberOf AuthenticateController
   * @description Check to see if user if logged in by calling LoginService.isLoggedIn()
   * @returns {boolean} true if user is logged in, false otherwise
   */
  isLoggedIn() {
    return this.loginService.isLoggedIn();
  }

  /**
   * @memberOf AuthenticateController
   * @description Get the info of the current user logged in by calling LoginService.currentUser()
   * @returns {string} payload of user
   */
  currentUser() {
    return this.loginService.currentUser();
  }
}

AuthenticateController.$inject = ['$state', '$location', 'LoginService'];




// WEBPACK FOOTER //
// ./src/client/app/authenticate/authenticate.controller.js